module.exports = __webpack_public_path__ + "icons/original/small/small-f3.5b7ae0c2d05c4e28148dc866a5094d67.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/small/small-f3.png
// module id = Hoba
// module chunks = app